import { AssetsSocial, RateAssetForm, Paging, UserSocial } from '@/types';
import { createActionCreator } from 'deox';

export const rateEntityActions = {
  request: createActionCreator('RATE_ENTITY_DOC_REQUEST', (resolve) => (id: string, rating: number) =>
    resolve({ id, rating })
  ),
  success: createActionCreator('RATE_ENTITY_DOC_SUCCESS'),
  failure: createActionCreator('RATE_ENTITY_DOC_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const rateAssetActions = {
  request: createActionCreator('RATE_ASSET_REQUEST', (resolve) => (formAsset: RateAssetForm, socialUserToken: string) =>
    resolve({ formAsset, socialUserToken })
  ),
  success: createActionCreator('RATE_ASSET_SUCCESS'),
  failure: createActionCreator('RATE_ASSET_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const fetchAssetSocialActions = {
  request: createActionCreator('FETCH_ASSET_SOCIAL_REQUEST', (resolve) => (socialUserToken: string) =>
    resolve({ socialUserToken })
  ),
  success: createActionCreator('FETCH_ASSET_SOCIAL_SUCCESS', (resolve) => (data: AssetsSocial) => resolve(data)),
  failure: createActionCreator('FETCH_ASSET_SOCIAL_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const exchangeSocialTokenActions = {
  request: createActionCreator(
    'EXCHANGE_SOCIAL_TOKEN_REQUEST',
    (resolve) => (socialToken: string, socialNetwork: string, email?: string, fullName?: string) =>
      resolve({ socialToken, socialNetwork, email, fullName })
  ),
  success: createActionCreator('EXCHANGE_SOCIAL_TOKEN_SUCCESS', (resolve) => () => resolve()),
  failure: createActionCreator('EXCHANGE_SOCIAL_TOKEN_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const fetchListUserSocialActions = {
  request: createActionCreator(
    'FETCH_LIST_USER_SOCIAL_REQUEST',
    (resolve) => (pageSize: number, pageNum: number, sort?: string, searchText?: string) =>
      resolve({ pageNum, pageSize, sort, searchText })
  ),
  success: createActionCreator(
    'FETCH_LIST_USER_SOCIAL_SUCCESS',
    (resolve) => ({ data, paging }: { data: UserSocial[]; paging: Paging }) => resolve({ data, paging })
  ),
  failure: createActionCreator('FETCH_LIST_USER_SOCIAL_FAILURE', (resolve) => (error: any) => resolve({ error })),
};
